import axios from 'axios'

export const mutations = {
  productRefresh (state, products) {
    state.all = products
    console.log('refresh products')
  },
  productExtend (state, product) {
    console.log('extend product')
    state.all.push(product)
  },
  productEdit (state, productToEdit) {
    console.log('edit product')
    state.editing = state.all.find((product) => { // returns the value of the first element that satisfies the condition
      return product._id === productToEdit
    })
  },
  productCancelEdit (state) {
    console.log('cancel edit product')
    state.editing = undefined
  },
  productCreate (state) {
    console.log('create product')
    state.editing = { // default value
      'customId': '',
      'name': '',
      'description': ''
    }
  },
  productUpdateOne (state, updated) {
    console.log('update one product')
    state.all = state.all.map((product) => { // replace the only updated product, others are intact
      return product._id === updated._id ? updated : product
    })
  },
  productToDelete (state, productToDelete) {
    console.log('product to delete')
    state.deleting = state.all.find((product) => { // returns the value of the first element that satisfies the condition
      return product._id === productToDelete._id
    })
  },
  productDeleted (state) {
    state.all = state.all.filter((product) => { // filter out the deleted product
      return product._id !== state.deleting._id
    })
    state.deleting = undefined
  },
  productCancelDelete (state) {
    console.log('cancel delete product')
    state.deleting = undefined
  }
}

export const getters = {
  allProducts: (state) => {
    return state.all
  },
  editingProduct: (state) => {
    return state.editing
  }
}

export default {
  state: {
    all: [],
    editing: undefined,
    deleting: undefined
  },
  getters,
  mutations,
  actions: {
    // ========================================
    fetchProducts: async ({ commit }) => {
      try {
        let products = await axios.get('/api/v1/products')
        commit('productRefresh', products.data)
      } catch (err) {
        commit('productRefresh', [])
      }
    },
    fetchOneProduct: async ({ commit }, productId) => {
      try {
        let product = await axios.get('/api/v1/products/' + productId)
        commit('productUpdateOne', product.data[0])
      } catch (err) {
        console.log(err)
      }
    },
    // ========================================
    saveProduct: async ({ commit, state }) => {
      console.log('run saveProduct', state.editing)
      try {
        if (state.editing._id !== undefined) {
          // Update existing product
          await axios.put('/api/v1/products/' + state.editing._id, state.editing)
          console.log('state.editing', state.editing)
          commit('productUpdateOne', state.editing)
        } else {
          // Add new product
          let response = await axios.post('/api/v1/products', state.editing)
          commit('productExtend', response.data) // insert a new product also with its _ID
        }
        commit('productCancelEdit')
      } catch (err) {
        console.log(err)
      }
    },
    // ========================================
    deleteProducts: async ({ commit, state }) => {
      console.log('run deleteProducts', state.deleting)
      try {
        await axios.delete('/api/v1/products/' + state.deleting._id)
        // after deleting the product we need to refresh productLists also
        let productLists = await axios.get('/api/v1/productLists')
        commit('productListRefresh', productLists.data)

        commit('productDeleted', state.deleting._id)
      } catch (err) {
        console.log(err)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Products.js